import clsx from 'clsx'
import { useFlag } from 'toggled'

import { flags } from '~/utils/constants'

export function useCounterStyles() {
  const hasCustomCounterColor = useFlag(flags.DEV_CUSTOM_COUNTER_COLOR)

  return (value: number) => {
    if (!hasCustomCounterColor) {
      return 'm-0.5'
    }

    return clsx('m-0.5', value > 0 ? 'bg-brand-secondary' : 'border-2 border-brand-secondary bg-white')
  }
}
